import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';



window.Vue = Vue;

Vue.use(BootstrapVue);
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});


Vue.mixin({
    methods: {

        get_datepickLang() {
            return datePick.lang;
        },

        obj_to_null(someObject){
            if(someObject == null ) {
                return null;
            }

            let res = Object.keys(someObject).length;

            if(res === 0) {
                return null;
            }
            return someObject;
        },

        re_map_text : function (item,type) {
            if(item.isPrototypeOf(String)) {
                return item;
            }

            else {
                if(type === 'label') {
                    return item.label;
                }

                if(type === 'text') {
                    return item.text;
                }
            }

        },

    },

    filters: {
        uppercase: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase()
        },

    },
});
